const debounce = function (func, wait = 0) {
  const state = {
    timeout: null,
    promise: null,
    resolve: null,
    previousFlushTime: 0,
    complete: true,
  };

  if (func == null)
    throw new Error("Error: Debounce have no function to call.");

  if (!(wait > 0))
    throw new Error("Error: Debounce wait is NOT a positive number.");

  const newPromiseIfComplete = () => {
    if (state.complete == true) {
      state.complete = false;
      state.promise = new Promise((resolve) => {
        state.resolve = resolve;
      });
    }
  };

  const executeFuncCall = (func, ...args) => {
    state.resolve(func(...args));
    state.complete = true;
  };

  const deferFuncCall = (func, wait, ...args) => {
    state.timeout = setTimeout(() => executeFuncCall(func, ...args), wait);
  };

  return (forceExecuteFunc, ...args) => {
    clearTimeout(state.timeout);
    newPromiseIfComplete(state);

    if (forceExecuteFunc) executeFuncCall(func, ...args);
    else deferFuncCall(func, wait, ...args);

    return state.promise;
  };
};

export { debounce };
